import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsCountWithdrawals = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/statistics/withdrawals/count`, {params});
};